import DynamicForm from "../common/DynamicForm";

const StudyConnectorsForm = (props: any) => {
  const { register, control, errors } = props;

  const fieldsJson = [
    {
      groupName: "study_connectors",
      title: "Study Connectors",
      fields: [
        {
          name: "connector_id",
          label: "Connector ID",
          size: 4,
          required: true,
        },
        {
          name: "name",
          label: "Name",
          size: 4,
          required: true,
        },
        {
          name: "study_ids",
          label: "Studies",
          size: 4,
          required: true,
        },
      ],
    },
  ];
  return (
    <DynamicForm
      fieldsJson={fieldsJson}
      errors={errors}
      register={register}
      control={control}
      groups
    />
  );
};

export default StudyConnectorsForm;
